/**
 * 错误提示组件
 * 验证需求：12.3
 */
import { Alert, Button } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';

interface ErrorAlertProps {
  error?: Error | string | null;
  message?: string;
  description?: string;
  showRetry?: boolean;
  onRetry?: () => void;
  type?: 'error' | 'warning' | 'info';
}

export default function ErrorAlert({
  error,
  message,
  description,
  showRetry = true,
  onRetry,
  type = 'error',
}: ErrorAlertProps) {
  if (!error && !message) {
    return null;
  }

  const errorMessage = message || (error instanceof Error ? error.message : String(error));
  const errorDescription = description || '请稍后重试或联系管理员';

  return (
    <Alert
      message={errorMessage}
      description={errorDescription}
      type={type}
      showIcon
      action={
        showRetry && onRetry ? (
          <Button size="small" icon={<ReloadOutlined />} onClick={onRetry}>
            重试
          </Button>
        ) : undefined
      }
      style={{ marginBottom: 16 }}
    />
  );
}
